(()=>{
  const norm=s=>(s||'').replace(/\s+/g,' ').trim();
  let videoDone=false,reviewDone=false,faqDone=false,queued=false,lastVideoTrigger=null;
  const mainHome=()=>[...document.querySelectorAll('.klx-home')].find(el=>el.querySelector('h1')&&el.querySelector('.klx-media-stage,#klx-amazon-videos'))||document.querySelector('.klx-home:not(.klx-faq-final-mount)');
  const showInserted=root=>{if(!root)return;root.querySelectorAll('[data-klx-add-reveal],.klx-reveal').forEach(el=>el.classList.add('is-in'))};

  const bindVideoUI=root=>{
    if(!root||root.dataset.klxVideoBound==='true')return;
    root.dataset.klxVideoBound='true';
    const modal=root.querySelector('[data-klx-video-modal]');
    const iframe=modal?.querySelector('[data-klx-video-iframe]');
    const title=modal?.querySelector('#klx-video-modal-title');
    if(!modal||!iframe)return;
    const closeVideo=()=>{iframe.src='';modal.hidden=true;document.documentElement.classList.remove('klx-video-modal-open');document.body.classList.remove('klx-video-modal-open');if(lastVideoTrigger){lastVideoTrigger.focus();lastVideoTrigger=null}};
    const openVideo=btn=>{const id=btn.dataset.klxVideoId;const videoTitle=btn.dataset.klxVideoTitle||'KLAXON Product Video';if(!id)return;lastVideoTrigger=btn;if(title)title.textContent=videoTitle;iframe.title=videoTitle;iframe.src='https://www.youtube-nocookie.com/embed/'+encodeURIComponent(id)+'?autoplay=1&rel=0&modestbranding=1&playsinline=1';modal.hidden=false;document.documentElement.classList.add('klx-video-modal-open');document.body.classList.add('klx-video-modal-open');requestAnimationFrame(()=>modal.querySelector('.klx-video-modal__close')?.focus())};
    root.addEventListener('click',e=>{const play=e.target.closest('[data-klx-video-id]');if(play&&root.contains(play)){openVideo(play);return}if(e.target.closest('[data-klx-video-close]'))closeVideo()});
    document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!modal.hidden)closeVideo()});
  };

  const bindCinema=root=>{
    const shell=root?.querySelector('[data-klx-cinema]');
    if(!shell||shell.dataset.klxCinemaReady==='true')return;
    shell.dataset.klxCinemaReady='true';
    const groups=[
      [...shell.querySelectorAll('[data-klx-cinema-left] [data-klx-cinema-card]')],
      [...shell.querySelectorAll('[data-klx-cinema-right] [data-klx-cinema-card]')]
    ];
    const dots=[...root.querySelectorAll('[data-klx-cinema-dot]')];
    const total=Math.min(...groups.map(g=>g.length).filter(Boolean),dots.length||99);
    let active=0,timer=null,paused=false;
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');

    const render=index=>{
      if(!Number.isFinite(total)||total<1)return;
      active=(index+total)%total;
      groups.forEach(cards=>cards.forEach((card,i)=>{
        const offset=(i-active+cards.length)%cards.length;
        card.classList.toggle('is-active',offset===0);
        card.classList.toggle('is-next',offset===1);
        card.classList.toggle('is-back',offset>1);
        card.setAttribute('aria-hidden',offset===0?'false':'true');
        card.querySelectorAll('a,button').forEach(el=>{if(offset===0)el.removeAttribute('tabindex');else el.setAttribute('tabindex','-1')});
      }));
      dots.forEach((dot,i)=>{const on=i===active;dot.classList.toggle('is-active',on);if(on)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current')});
    };
    const stop=()=>{if(timer){clearInterval(timer);timer=null}};
    const start=()=>{stop();if(total>1&&!paused&&!reduced.matches)timer=setInterval(()=>render(active+1),4600)};
    dots.forEach((dot,i)=>dot.addEventListener('click',()=>{render(i);start()}));
    shell.addEventListener('mouseenter',()=>{paused=true;stop()});
    shell.addEventListener('mouseleave',()=>{paused=false;start()});
    shell.addEventListener('focusin',()=>{paused=true;stop()});
    shell.addEventListener('focusout',e=>{if(!shell.contains(e.relatedTarget)){paused=false;start()}});
    reduced.addEventListener?.('change',start);
    render(0);start();

    const video=shell.querySelector('[data-klx-film-video]');
    const play=shell.querySelector('[data-klx-film-play]');
    const sound=shell.querySelector('[data-klx-film-sound]');
    if(video && !shell.querySelector('[data-klx-video-shell]')){
      video.muted=true;video.defaultMuted=true;
      const syncPlay=()=>{
        if(!play)return;
        const playing=!video.paused&&!video.ended;
        play.setAttribute('aria-pressed',playing?'true':'false');
        play.setAttribute('aria-label',playing?'Pause video':'Play video');
        const label=play.querySelector('span');if(label)label.textContent=playing?'Pause':'Play';
      };
      const tryPlay=()=>{if(!reduced.matches)video.play().catch(()=>{});syncPlay()};
      play?.addEventListener('click',()=>{video.paused?video.play().catch(()=>{}):video.pause();setTimeout(syncPlay,0)});
      sound?.addEventListener('click',()=>{
        video.muted=!video.muted;video.defaultMuted=video.muted;
        const on=!video.muted;
        sound.setAttribute('aria-pressed',on?'true':'false');
        sound.setAttribute('aria-label',on?'Turn video sound off':'Turn video sound on');
        const label=sound.querySelector('span');if(label)label.textContent=on?'Sound off':'Sound';
        if(on)video.play().catch(()=>{});
      });
      video.addEventListener('play',syncPlay);video.addEventListener('pause',syncPlay);
      if('IntersectionObserver' in window){
        const io=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting&&entry.intersectionRatio>=.28)tryPlay();else video.pause()})},{threshold:[0,.28,.7]});
        io.observe(video);
      }else tryPlay();
      if(reduced.matches)video.pause();
      syncPlay();
    }
  };

  const enhanceVideo=()=>{
    if(videoDone)return true;
    const home=mainHome(),tpl=document.getElementById('klx-amazon-video-template');
    if(!home||!tpl)return false;
    const section=document.getElementById('klx-amazon-videos')||home.querySelector('#klx-brand-film')?.closest('.klx-section')||home.querySelector('.klx-media-stage')?.closest('.klx-section');
    if(!section)return false;
    section.className='klx-section klx-amazon-videos';
    section.id='klx-amazon-videos';
    section.setAttribute('aria-labelledby','klx-film-title');
    section.innerHTML=tpl.innerHTML;
    bindVideoUI(section);bindCinema(section);showInserted(section);
    videoDone=true;return true;
  };

  const enhanceReviews=()=>{
    if(reviewDone)return true;
    const tpl=document.getElementById('klx-customer-review-template');
    const reviews=document.getElementById('klx-customer-feedback');
    if(!tpl||!reviews)return false;
    reviews.className='klx-add-section klx-add-section--soft klx-amazon-reviews klx-customer-reviews';
    reviews.setAttribute('aria-labelledby','klx-customer-review-title');
    reviews.innerHTML=tpl.innerHTML;showInserted(reviews);reviewDone=true;return true;
  };

  const moveFaq=()=>{
    if(faqDone)return true;
    const home=mainHome();if(!home)return false;
    const heading=[...home.querySelectorAll('h2')].find(h=>norm(h.textContent)==='Frequently Asked Questions');
    const faq=heading?.closest('.klx-section');if(!faq)return false;
    const mount=document.getElementById('klx-faq-final-mount');if(!mount){faq.style.display='none';faq.setAttribute('data-klx-faq-pending','true');return false}
    mount.appendChild(faq);faq.style.removeProperty('display');faq.removeAttribute('data-klx-faq-pending');showInserted(faq);faqDone=true;return true;
  };

  let observer;
  const run=()=>{queued=false;enhanceVideo();enhanceReviews();moveFaq();if(videoDone&&reviewDone&&faqDone&&observer)observer.disconnect()};
  const queue=()=>{if(queued)return;queued=true;requestAnimationFrame(run)};
  observer=new MutationObserver(queue);
  const start=()=>{run();if(!(videoDone&&reviewDone&&faqDone))observer.observe(document.body,{childList:true,subtree:true})};
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',start,{once:true}):start();
})();